export const EXTRA_SMALL = "480px"
export const SMALL = "840px"
export const LARGE = "1260px"


// WEBPACK FOOTER //
// ./src/commons/constants/BreakPoints.js